import { render, staticRenderFns } from "./agentManage.vue?vue&type=template&id=2c9c09aa&scoped=true&"
import script from "./agentManage.vue?vue&type=script&lang=js&"
export * from "./agentManage.vue?vue&type=script&lang=js&"
import style0 from "./agentManage.vue?vue&type=style&index=0&id=2c9c09aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c09aa",
  null
  
)

export default component.exports